// ============================================================
// usePageMeta Hook
// ============================================================
// Sets page title and breadcrumbs via UI store.

import { useEffect } from 'react';
import useUiStore from '@/store/uiStore';

export function usePageMeta(title, breadcrumbs = []) {
  const setPageMeta = useUiStore((state) => state.setPageMeta);

  useEffect(() => {
    setPageMeta({ title, breadcrumbs });
  }, [title, JSON.stringify(breadcrumbs), setPageMeta]);
}
